const settingsNames = ["layout", 'refreshRate', 'rangeSetting', 'scale', "domainMin", "domainMax"];
export const settings = (res) => {
    let settings = {};
    settingsNames.forEach(item => {
      settings[item] = res[item];
    })
    return settings;
  }


// WEBPACK FOOTER //
// ./src/libs/settings-lib.js